import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-status',
  templateUrl: './theme-status.component.html'
})
export class ThemeStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
